import React from 'react'

interface IconProps {
  width?: number
  height?: number
  className?: string
}

export const ArrowLeftIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.42-1.41L7.83 13H20v-2z"/>
  </svg>
)


export const ExportIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
  </svg>
)

export const NavigateFirstIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M17.7 15.89L13.82 12l3.88-3.89a.996.996 0 10-1.41-1.41L10.71 12l5.58 5.3a.996.996 0 101.41-1.41zM7 6a1 1 0 00-1 1v10a1 1 0 002 0V7a1 1 0 00-1-1z"/>
  </svg>
)

export const NavigateLastIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M6.3 8.11L10.18 12l-3.88 3.89a.996.996 0 101.41 1.41L13.29 12l-5.58-5.3a.996.996 0 00-1.41 1.41zM17 18a1 1 0 001-1V7a1 1 0 00-2 0v10a1 1 0 001 1z"/>
  </svg>
)

export const InfoIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
  </svg>
)

export const AccountIcon: React.FC<IconProps> = ({ width = 24, height = 24, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20z"/>
  </svg>
)

export const HelpIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"/>
  </svg>
)

export const LogoutIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
  </svg>
)

export const ChevronDownIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M7 10l5 5 5-5z"/>
  </svg>
)

export const BookIcon: React.FC<IconProps> = ({ width = 20, height = 20, className }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>
  </svg>
)
